import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData } from "../../../js/server";
import {
    cloneObj,
    fnFileDownload,
    fnNotLogin,
    fnNotOfficers,
} from "../../../js/util";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import SubMenu from "../../comm/SubMenu";
import SubBanner from "../../comm/SubBanner";
import Comment from "../../comm/Comment";
import {
    getServiceName,
    getSub01,
    getSub02,
    getSubHeader,
    wrapHTML,
} from "../../../js/util";
import ContentLoader from "react-content-loader";

function AdminBoardView({ match, location, history }) {
    const dispatch = useDispatch();
    const usehistory = useHistory();
    const query = queryString.parse(location.search);
    const bserial = query.bserial;
    const kind = query.kind;
    const page = query.page;
    const keyword = query.keyword;
    const [userToken, setUserToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [userType, setUserType] = useState(null);
    const [boardKind, setBoardKind] = useState(null); //게시판종류
    const [post, setPost] = useState({});
    const [comments, setComments] = useState([]);
    const [files, setFiles] = useState([]);
    const [comment, setComment] = useState([]);

    const fetchData = () => {
        const userinfo = JSON.parse(localStorage.getItem("userinfo"));
        console.log(kind);
        if (userinfo || kind === "free" || kind === "joboffer") {
            let _userToken = null;
            if (userinfo) {
                _userToken = userinfo.userToken;
            }

            const jsonData = {
                servicename: `${getServiceName(kind)}View`,
                userToken: _userToken,
                bserial: bserial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        setComments(res.data.jsonComment);
                        setPost(res.data.jsonData);
                        setFiles(res.data.jsonFile);
                    } else {
                        console.log(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnCommentClick = () => {
        if (comment.length < 5) {
            alert("댓글은 5자 이상 입력 가능합니다.");
            document.querySelector("#comment").focus();
        } else {
            if (window.confirm("댓글을 작성하시겠습니까?")) {
                //댓글 전송
                const jsonData = {
                    servicename: "CommentSave",
                    userToken: userToken,
                    jsonData: {
                        bserial: bserial,
                        writer: userName,
                        comment: comment,
                    },
                };

                dispatch({ type: "loadingChange", payload: true });
                reqData(jsonData)
                    .then((res) => {
                        if (res.data.result === "OK") {
                            let copiedObj = cloneObj(comments);
                            copiedObj.push(res.data.jsonData);
                            setComments(copiedObj);
                            setComment("");
                            document.querySelector("#comment").value = "";
                        } else {
                            alert(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        dispatch({ type: "loadingChange", payload: false });
                    });
            }
        }
    };

    const fnCommentDelete = (cserial, e) => {
        if (window.confirm("댓글을 삭제하시겠습니까?")) {
            const jsonData = {
                servicename: "CommentDelete",
                userToken: userToken,
                cserial: cserial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        let copiedObj = cloneObj(comments);
                        var idx = copiedObj.findIndex((i) => i.cserial === cserial);
                        if (idx > -1) copiedObj.splice(idx, 1);
                        setComments(copiedObj);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnCommentEdit = (cserial, isEdit, e) => {
        let copiedObj = cloneObj(comments);
        const idx = copiedObj.findIndex((i) => i.cserial === cserial);
        copiedObj[idx].isEdit = isEdit;
        setComments(copiedObj);
    };

    const fnCommentEditClick = (cserial, e) => {
        const obj = document.querySelector(`#comment_${cserial}`);
        const val = obj.value;

        if (val.length < 5) {
            alert("댓글은 5자 이상 입력 가능합니다.");
        } else {
            const jsonData = {
                servicename: "CommentSave",
                userToken: userToken,
                jsonData: {
                    cserial: cserial,
                    bserial: bserial,
                    writer: userName,
                    comment: val,
                },
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        let copiedObj = cloneObj(comments);
                        const idx = copiedObj.findIndex((i) => i.cserial === cserial);
                        copiedObj[idx].comment = val;
                        copiedObj[idx].isEdit = false;
                        setComments(copiedObj);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnBoardEdit = () => {
        usehistory.push(
            `/ABoardEdit?page=${page}&keyword=${encodeURI(
                keyword
            )}&kind=${kind}&bserial=${bserial}`
        );
    };

    const fnBoardDelete = () => {
        if (
            window.confirm("게시글을 삭제 하시겠습니까?\n삭제후 복구가 불가능합니다.")
        ) {
            const jsonData = {
                servicename: `${getServiceName(kind)}Delete`,
                userToken: userToken,
                bserial: bserial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        alert("삭제되었습니다.");
                        usehistory.push(
                            `/ABoardList?page=${page}&keyword=${encodeURI(
                                keyword
                            )}&kind=${kind}`
                        );
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    useEffect(
        () => {
            dispatch({
                type: "pageChange",
                payload: { sub01: getSub01(kind), sub02: getSub02(kind) },
            });
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                //로그인 체크
                const userinfo = JSON.parse(localStorage.getItem("userinfo"));

                if (userinfo) {
                    const _userToken = userinfo.userToken;
                    setUserToken(userinfo.userToken);
                    setBoardKind(kind);

                    //로그인 체크 후 Usertype 검사
                    LoginToken(_userToken)
                        .then((res) => {
                            if (res.data.result === "OK") {
                                setUserType(res.data.jsonData.usertype);
                                setUserId(res.data.jsonData.userid);
                                setUserName(res.data.jsonData.username);

                                if (
                                    //임원 자료실인 경우
                                    boardKind === "pds05" &&
                                    Number(res.data.jsonData.usertype) > 2
                                ) {
                                    fnNotOfficers();
                                } else if (
                                    //조합 자료실은 조합직원 이상만 열람 가능
                                    boardKind === "pds08" &&
                                    Number(res.data.jsonData.usertype) > 1
                                ) {
                                    fnNotOfficers();
                                } else {
                                    fetchData();
                                }
                            } else {
                                fnNotLogin();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            localStorage.removeItem("userinfo");

                            fnNotLogin();
                        })
                        .finally(() => {
                            dispatch({ type: "loadingChange", payload: false });
                        });
                } else {
                    if (kind !== "free" && kind !== "joboffer") {
                        fnNotLogin();
                    } else {
                        setBoardKind(kind);
                        fetchData();
                    }
                }
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <SubBanner id={kind} />

            <section className="adminboard section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">{getSubHeader(boardKind)}</div>

                            <div className="row pb-10 pt-20">
                                <div className="col-12">
                                    {
                                        (userType && Number(userType) < 2 && boardKind !== "pds08") ||
                                            (userType && Number(userType) < 1 && boardKind === "pds08") ||
                                            post.userid === userId ? (
                                            <>
                                                <button
                                                    className="btn btn-light btn-custom-sm"
                                                    type="button"
                                                    onClick={fnBoardEdit}
                                                >
                                                    <i className="icofont-edit"></i>&nbsp;수정
                                                </button>
                                                &nbsp;
                                                <button
                                                    className="btn btn-light btn-custom-sm"
                                                    type="button"
                                                    onClick={fnBoardDelete}
                                                >
                                                    <i className="icofont-ui-delete"></i>&nbsp;삭제
                                                </button>
                                                &nbsp;
                                            </>
                                        ) : null
                                    }
                                    <button
                                        className="btn btn-light btn-custom-sm"
                                        type="button"
                                        onClick={() =>
                                            usehistory.push(
                                                `/ABoardList?page=${page}&keyword=${encodeURI(
                                                    keyword
                                                )}&kind=${boardKind}`
                                            )
                                        }
                                    >
                                        <i className="icofont-list"></i>&nbsp;목록
                                    </button>
                                </div>
                            </div>

                            <hr />

                            <div className="blog-item-meta mb-3">
                                <span className="text-color-1 text-capitalize mr-3">
                                    <i className="icofont-user-alt-7 mr-2"></i>{" "}
                                    {post.writer || ""}
                                    {post.userid || (
                                        <ContentLoader
                                            speed={2}
                                            width={60}
                                            height={25}
                                            viewBox="0 0 60 25"
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                        >
                                            <rect x="0" y="0" rx="0" ry="0" width="60" height="25" />
                                        </ContentLoader>
                                    )}
                                </span>
                                <span className="text-muted text-capitalize mr-3">
                                    <i className="icofont-comment mr-2"></i>
                                    {post.comment_cnt || (
                                        <ContentLoader
                                            speed={2}
                                            width={30}
                                            height={25}
                                            viewBox="0 0 30 25"
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                        >
                                            <rect x="0" y="0" rx="0" ry="0" width="30" height="25" />
                                        </ContentLoader>
                                    )}
                                    개의 댓글
                                </span>
                                <span className="text-black text-capitalize mr-3">
                                    <i className="icofont-calendar mr-2"></i>
                                    {post.wdate || (
                                        <ContentLoader
                                            speed={2}
                                            width={150}
                                            height={25}
                                            viewBox="0 0 150 25"
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                        >
                                            <rect x="0" y="0" rx="0" ry="0" width="150" height="25" />
                                        </ContentLoader>
                                    )}
                                </span>
                            </div>

                            <div className="row pb-10">
                                <div className="col-12">
                                    <h3>
                                        {post.subject || (
                                            <ContentLoader
                                                speed={2}
                                                width={250}
                                                height={40}
                                                viewBox="0 0 250 40"
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb"
                                            >
                                                <rect
                                                    x="0"
                                                    y="0"
                                                    rx="0"
                                                    ry="0"
                                                    width="250"
                                                    height="40"
                                                />
                                            </ContentLoader>
                                        )}
                                    </h3>
                                </div>
                            </div>

                            <div className="row pt-10">
                                <div className="col-12 board-contents">
                                    {post.contents ? (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: wrapHTML(post.contents),
                                            }}
                                        />
                                    ) : (
                                        <ContentLoader
                                            speed={2}
                                            width={300}
                                            height={95}
                                            viewBox="0 0 300 95"
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                        >
                                            <rect x="0" y="0" rx="0" ry="0" width="300" height="25" />
                                            <rect
                                                x="0"
                                                y="35"
                                                rx="0"
                                                ry="0"
                                                width="250"
                                                height="25"
                                            />
                                            <rect
                                                x="0"
                                                y="70"
                                                rx="0"
                                                ry="0"
                                                width="250"
                                                height="25"
                                            />
                                        </ContentLoader>
                                    )}
                                </div>
                            </div>

                            {files.length > 0 ? (
                                <div className="row pt-10">
                                    <div className="col-12">
                                        <div className="mt-3 clearfix">
                                            <ul className="float-right list-inline">
                                                <li className="text-right"> 첨부파일</li>
                                                {files.map((file, i) => {
                                                    return (
                                                        <li
                                                            className="text-right"
                                                            key={i}
                                                            onClick={() =>
                                                                fnFileDownload(file.file_url, file.file_name)
                                                            }
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <i
                                                                className="icofont-diskette pr-2"
                                                                title={file.file_name}
                                                            />
                                                            {file.file_name}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {/* 댓글 component */}
                            <Comment
                                comments={comments}
                                userType={userType}
                                userId={userId}
                                setComment={setComment}
                                fnCommentEdit={fnCommentEdit}
                                fnCommentDelete={fnCommentDelete}
                                fnCommentClick={fnCommentClick}
                                fnCommentEditClick={fnCommentEditClick}
                            />
                        </div>

                        <SubMenu id={boardKind} />
                    </div>
                </div>
            </section>
        </>
    );
}

export default AdminBoardView;
